<template>
    <div>
        <div class="filter-block">
            <div class="filter-block-left">
                <i class="fa fa-filter" style="margin-right: 10px;"></i>
                <el-input v-model="filter.review_asin"  @input="oninput" size="mini" placeholder="请输入ASIN" style="width: 150px;margin-right: 5px;" clearable></el-input>
                <el-input v-model="filter.review"  @input="oninput" size="mini" placeholder="请输入评价标题和内容" style="width: 200px;margin-right: 5px;" clearable></el-input>
                <el-input v-model="filter.remark"  @input="oninput" size="mini" placeholder="请输入备注" style="width: 200px;margin-right: 5px;" clearable></el-input>
            </div>
            <el-select v-model="filter.dropped" placeholder="是否掉评" size="mini" style="width: 100px" clearable @change="change">
                <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
        </div>
        <el-table
            v-loading="loading"
            :data="list"
            :header-cell-style="{background:'#d1e1ff','font-size':'12px'}"
            size="mini"
            ref="multipleTables">
            <el-table-column
                width="140"
                align="center"
                label="ASIN">
                <template slot-scope="scope">
                    <div v-if="scope.row.review_asin != null" @click.stop="edirectToAsin(scope.row)" style="cursor: pointer;color: rgb(52, 73, 94);">
                        <i class="el-icon-s-promotion" style="margin-right:5px;"></i>{{ scope.row.review_asin }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="评论标题"
                align="center"
                min-width="100">
                <template slot-scope="scope">
                    <span style="word-break: break-word !important;">{{ scope.row.review_title }}</span>
                </template>
            </el-table-column>
            <el-table-column
                min-width="200"
                label="评论内容">
                <template slot-scope="scope">
                    <span style="word-break: break-word !important;">{{ scope.row.review_text }}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="130"
                align="center"
                label="备注">
                <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.remark == null || scope.row.remark == ''" class="item" effect="dark" content="点击添加备注" placement="top-start">
                        <div @click="addremark(scope.row, '添加备注')">暂无备注</div>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" content="修改备注" placement="top-start">
                        <div @click="addremark(scope.row, '修改备注')">{{ scope.row.remark }}</div>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column
                width="70"
                align="center"
                label="评论链接">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="'点击跳转链接地址：' + scope.row.link" placement="top-start">
                        <!-- <i class="el-icon-document-copy pen" @click="copy(scope.row)"></i> -->
                        <i class="el-icon-position Fine_tuning_b pen" style="font-size: 15px;" @click="tolink(scope.row.link)"></i>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column
                width="100"
                align="center"
                label="评论用户链接">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="'点击跳转链接地址：' + scope.row.review_user_link" placement="top-start">
                        <!-- <i class="el-icon-document-copy pen" @click="copy(scope.row)"></i> -->
                        <i class="el-icon-position Fine_tuning_b pen" style="font-size: 15px;" @click="tolink(scope.row.review_user_link)"></i>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column
                label="评价星级"
                align="center"
                width="70">
                <template slot-scope="scope">
                    <div>{{ scope.row.review_star }} 星</div>
                    <!-- <el-rate
                        v-model="scope.row.review_star"
                        disabled
                        text-color="#ff9900">
                    </el-rate> -->
                </template>
            </el-table-column>
            <el-table-column
                width="80"
                align="center"
                label="是否掉评">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.review_failure == 0" type="success">未掉评</el-tag>
                    <el-tag v-else-if="scope.row.review_failure == 1" type="info">已掉评</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                label="掉评时间"
                align="center"
                width="134">
                <template slot-scope="scope">
                    <div> {{scope.row.review_failure_time}} </div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                label="添加时间"
                align="center"
                width="134">
                <template slot-scope="scope">
                    <div> {{scope.row.add_time}} </div>
                </template>
            </el-table-column>
            <el-table-column
                width="80"
                align="center"
                label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="deleteEvaluation(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="margin-top: 5px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next">
        </el-pagination>
        <onremark :visible="ctrl.onremarkDialogVisible" :formData="formData" :title="ctrl.dialogTitle" @close-callback="closeCllback"></onremark>
    </div>
</template>
<script>
import * as api from "@/api/evaluation/evaluation";
import Onremark from "./onremark";
import { link_us } from "@/utils/method";
export default {
    components: { Onremark },
    props: {
        datasrow: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            loading: false,
            list: [],
            roles: [
                {
                    id: 1,
                    name: "已掉评"
                },
                {
                    id: 0,
                    name: "未掉评"
                }
            ],
            ctrl: {
                onremarkDialogVisible: false
            },
            query: {
                page: 1,
                limit: 20
            },
            filter: {},
            formData: {}
        };
    },
    methods: {
        getList() {
            let obj = this.query;
            obj.filter = this.filter;
            obj.parent_asin = this.datasrow.parent_asin;
            this.loading = true;
            api.product_review_page_list(obj)
                .then(async res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.data.list;
                        this.query.page = res.data.page;
                        this.query.total = res.data.total;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //跳转到评论链接页面
        tolink(link) {
            window.open(link, "_blank");
        },
        //跳转到亚马逊产品页面
        edirectToAsin(data) {
            let url =
                link_us(this.datasrow.country_code) +
                "dp/" +
                data.review_asin +
                "?th=1&psc=1";
            window.open(url, "_blank");
        },
        //筛选
        change() {
            this.query.page = 1;
            this.getList();
        },
        //删除评价监控
        deleteEvaluation(data) {
            this.$confirm(`确定要删除这个评价监控吗?`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.remove({ id: data.id }).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                type: "success",
                                message: "删除评价监控成功"
                            });
                            this.getList();
                            this.$emit("close-list", this.datasrow);
                        } else {
                            this.$message({
                                type: "error",
                                message: res.message
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        //搜索
        oninput() {
            let that = this;
            clearTimeout(this.timeout);
            that.timeout = setTimeout(() => {
                that.query.page = 1;
                that.getList();
            }, 800);
        },
        //添加备注
        addremark(data, str) {
            this.formData = data;
            this.ctrl.onremarkDialogVisible = true;
            this.ctrl.dialogTitle = str;
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.onremarkDialogVisible = false;
            if (isshow) return;
            this.getList();
        }
    }
};
</script>
<style type="text/scss" lang="scss">
.el-tooltip__popper {
    max-width: 300px !important;
}
</style>
<style type="text/scss" lang="scss" scoped>
.pen {
    cursor: pointer;
}
.pen:hover {
    text-decoration: underline;
}
.line {
    display: inline-block;
}
/deep/ .el-divider--horizontal {
    margin: 8px 0 4px 0 !important;
}
.filter-block {
    background-color: #a9c7ff;
    padding: 6px 6px 6px 10px;
    font-size: 18px;
    color: #333;
    margin: 0;
    display: flex;
    // justify-content: space-between;
    align-items: center;
}
.filter-block-left {
    display: flex;
    align-items: center;
}
/deep/ .el-table--border {
    border: none;
}
</style>
